import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import deviceController from '../../redux/api/tbDeviceController';
import telemetryController from '../../redux/api/tbTelemetryController';
import cameraController from '../../redux/api/cameraController';

const initialState = {
  attribute: [],
  status: 'idle',
  rectangles: [],
};

export const getCamera = createAsyncThunk(
  'getCamera',
  async (data) => {
    const { token, deviceId } = data;
    let attribute = await telemetryController.getAttributesByScope(
      token,
      'DEVICE',
      deviceId,
      'cameraID'
    );
    
    const response = await cameraController.getCamera(token, attribute[0].value);
    return response;
  }
);

export const tenantAttributeInfos = createAsyncThunk(
  'tenantAttributeInfos',
  async (data) => {
    const { token } = data;
    let response = await deviceController.getTenantDeviceInfos(token, 'vts');
    const result = await Promise.all(
      response.data.map(async (item) => {
        let attribute = await telemetryController.getAttributesByScope(
          token,
          'DEVICE',
          item.id.id,
          'operationImage,operationData,phoneList,cameraID'
        );
        let operationImage, operationData, phoneList;
        Object.values(attribute).map((item) => {
          if (item['key'] === 'phoneList') phoneList = item.value;
          if (item['key'] === 'operationImage') operationImage = item.value;
          if (item['key'] === 'operationData') operationData = item.value;
        });
        return {
          ...item,
          attributes: {
            phoneList: phoneList,
            operationImage: operationImage,
            operationData: operationData,
          },
        };
      })
    );
    return result;
  }
);

export const uploadImageDiagram = createAsyncThunk(
  'uploadImageDiagram',
  async (data) => {
    const { token, deviceId, file } = data;
    const response = await telemetryController.saveEntityAttributesV1(
      token,
      'DEVICE',
      deviceId,
      {
        operationImage: file,
      }
    );
    return response;
  }
);

export const saveOperationDataDiagram = createAsyncThunk(
  'saveOperationDataDiagram',
  async (data) => {
    const { token, deviceId, arrMachine } = data;
    const response = await telemetryController.saveEntityAttributesV1(
      token,
      'DEVICE',
      deviceId,
      {
        operationData: arrMachine,
      }
    );
    return response;
  }
);

export const savePhoneList = createAsyncThunk('phoneList', async (data) => {
  const { token, dataPhone, deviceId } = data;
  const response = await telemetryController.saveEntityAttributesV2(
    token,
    'DEVICE',
    deviceId,
    {
      phoneList: dataPhone,
    }
  );

  return response;
});

export const attributeSlice = createSlice({
  name: 'attribute',
  initialState,
  reducers: {
    // action : rectangles
    addNewArr(state, action) {
      state.rectangles = action.payload;
    },
    fcNumberKey(state, action) {
      state.numberKey = action.payload;
    },
    fcConfirmX(state, action) {
      state.confirmX = action.payload;
    },
    fcConfirmY(state, action) {
      state.confirmY = action.payload;
    },
    isCancel(state, action) {
      state.cancel = action.payload;
    },
    isNotify(state, action) {
      state.notify = action.payload;
    },
  },
  extraReducers: (builder) => {
    
    builder.addCase(getCamera.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(getCamera.fulfilled, (state, action) => {
      state.status = 'success';
      state.camera = action.payload;
    });
    builder.addCase(getCamera.rejected, (state) => {
      state.status = 'failed';
    });

    builder.addCase(tenantAttributeInfos.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(tenantAttributeInfos.fulfilled, (state, action) => {
      state.status = 'success';
      state.tenantAttribute = action.payload;
    });
    builder.addCase(tenantAttributeInfos.rejected, (state) => {
      state.status = 'failed';
    });

    // change avatar
    builder.addCase(uploadImageDiagram.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(uploadImageDiagram.fulfilled, (state, action) => {
      state.status = 'idle';
      toast.success('The image diagram has been uploaded successfully.');
    });
    builder.addCase(uploadImageDiagram.rejected, (state) => {
      state.status = 'failed';
      toast.error('Something went wrong!');
    });

    // save data machine
    builder.addCase(saveOperationDataDiagram.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(saveOperationDataDiagram.fulfilled, (state, action) => {
      state.status = 'idle';
      toast.success('Save data successfully.');
    });
    builder.addCase(saveOperationDataDiagram.rejected, (state) => {
      state.status = 'failed';
      toast.error('Something went wrong!');
    });

    // save phone list
    builder.addCase(savePhoneList.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(savePhoneList.fulfilled, (state, action) => {
      state.status = 'idle';
      toast.success('Successfully.');
    });
    builder.addCase(savePhoneList.rejected, (state) => {
      state.status = 'failed';
      toast.error('Something went wrong!');
    });
  },
});

export const {
  addNewArr,
  fcNumberKey,
  fcConfirmX,
  fcConfirmY,
  isCancel,
  isNotify,
} = attributeSlice.actions;

export default attributeSlice.reducer;

export const allTenantAttribute = (state) => state.attribute.tenantAttribute;
